import {
  Flex,
  HStack,
  Box,
  chakra,
  Avatar,
  WrapItem,
  Table,
  Text,
  Tr,
  Td,
  TableContainer,
  VStack,
  useDisclosure,
  Heading,
  Image,
  Spinner,
  Icon,
  Button,
} from '@chakra-ui/react';
import { StarIcon } from '@chakra-ui/icons';
import React, { useContext, useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SearchContext } from './SearchContext';
import Loading from '../../Loading';
import '../css/lista-medicos.css';
import DotsLoading from '../../Utils/Components/DotsLoading';
import { AccountContext } from '../../AccountContext';
import haversine from 'haversine-distance';
import { SiGooglemaps } from 'react-icons/si';
import BottomNavBar from 'components/BottomNavBar';
import AvisoSemMedicos from './Telemedicina/MedicoAgora/Modal/AvisoSemMedicos';
import Searchbox from './Searchbox';
import VishMedicos from '../../../images/VishMedicos.svg';
import { userIsSubscriber } from 'components/Utils/theme';
import { IoIosAlert, IoMdCalendar } from 'react-icons/io';
import { RiMapPin2Fill } from 'react-icons/ri';
import empresa from '../../../images/dashboard/empresa.svg';

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
function ListaMedicos(props) {
  const pic = getRandomInt(0, 999);
  const navigate = useNavigate();
  const { user } = useContext(AccountContext);
  const { id_contrato, titular } = user;
  const state = useLocation();
  const [isLoading, setLoading] = useState(true);
  const typeList = props.typeList;
  const especialidade = props.especialidade;

  const isAndroid = user.device === 'android' ? true : false;

  var mapUriPrefix = 'https://maps.apple.com/?q=';
  if (isAndroid) mapUriPrefix = 'https://maps.google.com/?q=';
  const {
    medicos,
    loadingMedicos,
    fetchData,
    searchContext,
    lastSearch,
    profession,
    professionList,
    setProfession,
    setAvaliacoesAtualizadas,
    avaliacoes_atualizadas,
  } = useContext(SearchContext);
  const { webviewParams, toastInadimplente } = useContext(AccountContext);
  const [medicos2, setMedicos2] = useState(medicos);
  const [fetchMore, setFetchMore] = useState(false);
  const disclousureSemMedicos = useDisclosure();
  const sexo = user?.loggedIn ? (user.sexo === 'M' || user.sexo === 'm' ? 'M' : user.sexo === 'F' || user.sexo === 'f' ? 'F' : '') : null;

  useEffect(() => {
    setMedicos2(medicos);
  }, [medicos]);

  const dataAtual = new Date();

  let data_parcela = '';
  if (user.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }

  useEffect(() => {
    if (user.qntdeParcelas?.countParcelas && user.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela) {
      toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
    }
  }, []);

  useEffect(() => {
    setLoading(false);
    var busyStack = false;
    var page = 1;

    const handleScroll = async () => {
      let urlPart;
      if (user.coords != null) {
        urlPart = `&lat=${user.coords.latitudeAtual}&lng=${user.coords.longitudeAtual}`;
      } else {
        if (
          user.coordenadas_cidade &&
          user.coordenadas_cidade.latitude !== null &&
          user.coordenadas_cidade.latitude !== 'null' &&
          user.coordenadas_cidade.latitude !== undefined &&
          user.coordenadas_cidade.latitude !== 'undefined'
        ) {
          urlPart = `&lat=${user.coordenadas_cidade.latitude}&lng=${user.coordenadas_cidade.longitude}`;
        } else {
          urlPart = `&city=${user.cidade ? user.cidade : 'FORTALEZA'}`;
        }
      }

      if (window.innerHeight + window.scrollY + 10 > document.body.offsetHeight && busyStack === false) {
        setFetchMore(true);
        busyStack = true;
        let url =
          ENDPOINT + `/schedule/searchMedicos?page=${page + 1}&limit=${10}${urlPart}&profession=${profession}&typeList=${typeList}&sexo=${sexo}`;
        if (searchContext === 'search')
          url = ENDPOINT + `/schedule/searchMedicos?text=${lastSearch}&page=${page + 1}&limit=${10}${urlPart}&typeList=${typeList}&sexo=${sexo}`;
        let data = await fetchData(url);
        let lastPage = data.length === 0;
        if (!lastPage) busyStack = false;
        setMedicos2((prev) => [...prev, ...data]);
        page++;
        setFetchMore(false);
        return;
      }
    };

    window.removeEventListener('scroll', handleScroll);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [profession, searchContext, lastSearch, user]);
  const assinante = userIsSubscriber(user);
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;
  useEffect(() => {
    if (!clientePendente) {
      toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
    }
  }, [assinante, clientePendente]);
  const [modalAviso, setModalAviso] = useState(false);
  const [elementoClicado, setElementoClicado] = useState(false);
  let filteredProfessions = professionList;
  if (typeList === 'Dentistas') {
    filteredProfessions = professionList.filter((prof) => prof.profissoes_id === 2);
  }

  if (typeList === 'Medicos' || typeList === 'Médicos') {
    filteredProfessions = professionList.filter((prof) => prof.medico === true);
  }

  if (typeList === 'Outros') {
    filteredProfessions = professionList.filter((prof) => prof.profissoes_id !== 11 && prof.profissoes_id !== 2 && prof.medico === false);
  }

  const useProfessions = [
    <Td key="todos" px={2} py={3}>
      <Text
        id="todos-profissoes"
        className={elementoClicado === false ? 'elemento-clicado' : ''}
        color={elementoClicado === false ? 'white' : '#5AB2AE'}
        border={elementoClicado === false ? '1px solid #5AB2AE' : '1px solid #5AB2AE'}
        px={4}
        py={2.5}
        borderRadius="full"
        fontSize="1em"
        textAlign="center"
        cursor={loadingMedicos ? 'not-allowed' : 'pointer'}
        transition="all 0.2s ease"
        minW="140px"
        _hover={
          !loadingMedicos
            ? {
                transform: 'translateY(-1px)',
              }
            : {}
        }
        onClick={() => {
          if (!loadingMedicos) {
            setProfession('');
            setElementoClicado(false);
          }
        }}
      >
        Todos
      </Text>
    </Td>,
    ...filteredProfessions.map((prof, index) => {
      const isClicado = elementoClicado === index;
      return (
        <Td key={prof.profissoes_id} px={2} py={3}>
          <Text
            id={prof.nome}
            className={isClicado ? 'elemento-clicado' : ''}
            color={isClicado ? 'white' : '#5AB2AE'}
            border={isClicado ? '1px solid #5AB2AE' : '1px solid #5AB2AE'}
            px={4}
            py={2.5}
            borderRadius="full"
            fontSize="1em"
            textAlign="center"
            cursor={loadingMedicos ? 'not-allowed' : 'pointer'}
            transition="all 0.2s ease"
            minW="140px"
            _hover={
              !loadingMedicos
                ? {
                    transform: 'translateY(-1px)',
                  }
                : {}
            }
            onClick={() => {
              if (!loadingMedicos) {
                document.getElementById(prof.nome).scrollIntoView({ inline: 'center', behavior: 'smooth' });
                setProfession(prof.nome);
                setElementoClicado(index);
              }
            }}
          >
            {prof.nome}
          </Text>
        </Td>
      );
    }),
  ];

  let filteredMedicos = medicos2;
  /*if (typeList === 'Medicos') {
    filteredMedicos = medicos2.filter((prop) => prop?.dados?.flag_medico === true && prop?.dados?.agenda_especialidade === false);
  }
  if (typeList === 'Outros') {
    filteredMedicos = medicos2.filter(
      (prop) =>
        prop?.dados?.flag_medico === false &&
        ![85, 66, 76].includes(prop?.dados?.ambulatorio_tipo_consulta_id) &&
        prop?.dados?.agenda_especialidade === false
    );
  }
  if (typeList === 'Especialista') {
    filteredMedicos = medicos2.filter((prop) => [props?.especialidade].includes(prop?.dados?.ambulatorio_tipo_consulta_id));
  }*/

  const tratarNome = (nomeCompleto) => {
    if (!nomeCompleto) return '';

    const capitalizar = (palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();

    const partes = nomeCompleto.trim().split(/\s+/).filter(Boolean);

    if (partes.length === 0) return '';
    if (partes.length === 1) return capitalizar(partes[0]);

    const primeiroNome = capitalizar(partes[0]);
    const ultimoNome = capitalizar(partes[partes.length - 1]);

    return `${primeiroNome} ${ultimoNome}`;
  };

  const AvaliacaoEstrela = ({ avaliacao }) => {
    const [avaliacaoMedia, setAvaliacaoMedia] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const formatarAvaliacao = (media) => {
      const valor = Math.floor(media * 10) / 10;
      return valor.toFixed(1);
    };

    useEffect(() => {
      if (avaliacao) {
        const media =
          !avaliacao.avaliacao_media || avaliacao.avaliacao_media === '0' ? 5 : avaliacao.avaliacao_media >= 1 ? avaliacao.avaliacao_media : 5;
        setAvaliacaoMedia(formatarAvaliacao(media));
        setIsLoading(false);
      }
    }, [avaliacao]);
    return (
      <chakra.span mt={-0.5}>
        <StarIcon color="orange" fontSize="1em" mt={-0.3} />
        <chakra.span fontSize="0.625em" color="orange" fontWeight={300} ml={1}>
          {isLoading ? <Spinner size="sm" color="#5ab2ae" /> : avaliacaoMedia}
        </chakra.span>
      </chakra.span>
    );
  };

  const toCamelCase = (text = '') =>
    text
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  const useMedicos = useMemo(() => {
    return filteredMedicos.map((medico, index) => {
      const arrName = medico.dados.nome.split(' ');
      const preposicoes = ['das', 'dos', 'des', 'da', 'do', 'de'];
      const nomeMedico = Array.isArray(arrName)
        ? arrName.filter((name, index) => index <= 1 && preposicoes.includes(name.toLowerCase()) === false).join(' ')
        : '';

      if (!medico.horarios) {
        medico.horarios = [
          {
            AVA_DATE: '0',
            procedimentos: [
              {
                id: 0,
                nome: '',
                valor: '0',
                convenio_id: 0,
                procedimento_particular: [
                  {
                    particular_id: 0,
                    particular_valor: '0',
                  },
                ],
              },
            ],
          },
        ];
      }

      const isButtonDisabled = !medico.horarios || !medico.horarios[0].procedimentos || medico.horarios[0].AVA_DATE === '0';

      const event = new Date(medico.horarios[0].AVA_DATE.split('/').reverse().join('-') + 'T08:00:00');

      //const avaliacao = Math.round(medico.dados.avaliacao_media);
      const urlMapa = `${mapUriPrefix}${medico.dados.logradouro}, ${medico.dados.numero}, ${medico.dados.bairro}, ${medico.dados.municipio}, Ceará`;
      const options = { weekday: 'long', month: 'long', day: 'numeric' };
      let titulo = '';
      let promocao = '';
      if (medico.dados.sexo === 'M') {
        titulo = 'Dr. ';
      } else if (medico.dados.sexo === 'F') {
        titulo = 'Dra. ';
      }
      const avaliacao = avaliacoes_atualizadas.find((avaliacao) => avaliacao.operador_id === medico.dados.medico_id);
      const proxima_data = medico.horarios[0].AVA_DATE;
      return (
        <>
          <Flex align="center" borderRadius="2em" p={3} mb={2} boxShadow="lg" w="100%" flexWrap="wrap" overflow="hidden">
            <Avatar
              alt={tratarNome(medico?.dados?.nome || medico?.nome)}
              boxSize="56px"
              borderRadius="lg"
              mr={{ base: 0, sm: 4 }}
              mb={{ base: 3, sm: 0 }}
              id={medico.dados.medico_id}
              name={tratarNome(medico?.dados?.nome || medico?.nome)}
              src={
                medico?.foto ||
                medico?.dados?.foto ||
                `${process.env.REACT_APP_URL_PROFILEPICS_OPERADOR}/${medico?.dados?.medico}/foto_profissional.png`
              }
              mt={2}
              fontSize="0.75rem"
              color="white"
              bg="#5AB2AE"
              onClick={() => navigate('/empresa/medico/curriculo', { state: { medico, avaliacao: avaliacao } })}
            />

            <Box flex="1" minW={{ base: '100%', sm: '180px' }} pr={{ base: 0, sm: 2 }}>
              <HStack w="100%" justify="space-between" align="center" spacing={2}>
                <Text fontWeight="bold" fontSize="md" color="#616161" isTruncated maxW={{ base: '110px', sm: '180px' }}>
                  {titulo} {tratarNome(medico?.dados?.nome || medico?.nome)}
                </Text>

                <AvaliacaoEstrela avaliacao={avaliacao} />
              </HStack>

              <Text fontSize="sm" color="#4A4A4A" noOfLines={2} maxW="180px" wordBreak="break-word">
                {medico?.dados?.especialidade || medico?.especialidade}
              </Text>
              <Text fontSize="0.8em" color="#818181" noOfLines={2}>
                {medico?.dados?.conselho && medico?.dados?.conselho}
                {medico?.dados?.conselho && medico?.dados?.rqe && ' '}
                {medico?.dados?.rqe && medico?.dados?.rqe}
              </Text>
            </Box>

            <Flex mt={4} w="100%" align="flex-start" flexDirection="column">
              <HStack mb={1}>
                <Image src={empresa} boxSize="16px" />
                <chakra.p fontSize="lg" color="#757575" fontWeight="bold" wordBreak="break-word">
                  {toCamelCase(medico.dados.empresa)}
                </chakra.p>
              </HStack>

              <chakra.p fontSize="sm" color="#9E9E9E" textDecor="underline" wordBreak="break-word">
                <Icon as={RiMapPin2Fill} mr={1} color="red" cursor="pointer" onClick={() => window.open(urlMapa, '_blank')} />
                {toCamelCase(medico.dados.logradouro)},{` ${toCamelCase(medico.dados.numero)} - `}
                {toCamelCase(medico.dados.bairro)} - {toCamelCase(medico.dados.municipio)}
              </chakra.p>
            </Flex>

            <Flex mt={4} w="100%" justify="space-between" align="center" gap={4} direction={{ base: 'column', sm: 'row' }}>
              <Flex direction="column" align="flex-start" gap={1}>
                <p
                  style={{
                    color: '#9E9E9E',
                    fontSize:"0.7em",
                  }}
                >
                  Consulta por
                </p>

                <Text fontSize="md" color="#757575" fontWeight="bold" whiteSpace="nowrap">
                  {(() => {
                    const valorConsulta = Number(medico?.horarios[0]?.procedimentos?.[0]?.valor || 0);
                    const valorParticular = Number(medico?.horarios[0]?.procedimentos?.[0]?.procedimento_particular?.[0]?.particular_valor || 0);

                    const valor = assinante ? valorConsulta : valorParticular;

                    return new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(valor);
                  })()}
                </Text>
              </Flex>

              <Button
                fontWeight="normal"
                bg="#5AB2AE"
                borderRadius="2em"
                px={3}
                py={2}
                w="fit-content"
                minW="unset"
                flexShrink={0}
                fontSize="sm"
                color="white"
                whiteSpace="nowrap"
                leftIcon={<Icon as={IoMdCalendar} boxSize={4} color="white" />}
                onClick={() => {
                  if (!medico.horarios[0].procedimentos && !isButtonDisabled) {
                    navigate('/atendimento/agendamento', {
                      state: {
                        medico,
                        startNum: 0,
                        st: 0,
                        defaultDateTime: null,
                        procedimentoId: medico.horarios[0].ACTIVITY_LID,
                        procedimento: medico.horarios[0].ACTIVITY_NAME,
                        price: medico.horarios[0].PRICE,
                        avaliacao: avaliacoes_atualizadas,
                      },
                    });
                  } else {
                    if (!isButtonDisabled) {
                      navigate('/atendimento/agendamento', {
                        state: {
                          medico,
                          startNum: 0,
                          st: 0,
                          defaultDateTime: null,
                          procedimentoId: medico.horarios[0].procedimentos[0].id,
                          procedimento: medico.horarios[0].procedimentos[0].nome,
                          price: medico.horarios[0].procedimentos[0].valor,
                          procedimentoParticular: medico.horarios?.[0]?.procedimentos?.[0]?.procedimento_particular?.[0]?.particular_id ?? null,
                          valorParticular: medico.horarios?.[0]?.procedimentos?.[0]?.procedimento_particular?.[0]?.particular_valor ?? null,
                          restricao_sexo: medico.horarios[0].procedimentos[0].restricao_sexo,
                          avaliacao: avaliacoes_atualizadas,
                        },
                      });
                    } else if (!isButtonDisabled) {
                      navigate('/atendimento/escolha-procedimento', {
                        state: {
                          medico,
                          startNum: 0,
                          st: 0,
                          defaultDateTime: null,
                          avaliacao: avaliacoes_atualizadas,
                        },
                      });
                    }
                  }
                }}
              >
                Próxima data:{' '}
                {!proxima_data ? (
                  <Spinner size="sm" ml={2} />
                ) : (
                  (() => {
                    const d = new Date(proxima_data.split('/').reverse().join('-') + 'T08:00:00');
                    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getFullYear()).slice(
                      -2,
                    )}`;
                  })()
                )}
              </Button>
            </Flex>
          </Flex>
        </>
      );
    });
  }, [filteredMedicos, avaliacoes_atualizadas, mapUriPrefix, pic]);
  console.log('Renderizou ListaMedicos', loadingMedicos);
  return (
    <>
      <VStack w={'100%'} mb={10}>
        <Box mt={5} justifyContent="center" w={'100%'}>
          <Searchbox />
        </Box>
        {typeList !== 'Dentistas' && typeList !== 'Especialista' && (
          <TableContainer w="100%" overflowY="auto">
            <Table variant="simple">
              <Tr>{professionList && useProfessions}</Tr>
            </Table>
          </TableContainer>
        )}
        {!loadingMedicos && medicos2.length > 0 && (
          <>
            {medicos2 && useMedicos} {fetchMore && <DotsLoading />}
          </>
        )}
        {(loadingMedicos || isLoading) && (
          <VStack w="100%" maxW="320px" m="auto" justify="center" align="center" spacing={3} py={6}>
            <Loading />
          </VStack>
        )}

        {!loadingMedicos && !isLoading && medicos2.length === 0 && (
          <VStack w="100%" maxW="320px" m="auto" justify="center" align="center" spacing={3} py={6}>
            <Image src={VishMedicos} boxSize="96px" opacity={0.9} />

            <Heading fontSize="lg" textAlign="center" color="gray.700" fontWeight="semibold">
              Ops...
            </Heading>

            <Text fontSize="md" textAlign="center" color="gray.600" lineHeight="1.4">
              Nenhum <strong>{typeList === 'Medicos' ? 'médico' : typeList === 'Dentistas' ? 'dentista' : 'profissional de saúde'}</strong> está
              disponível no momento.
            </Text>

            <Text fontSize="sm" textAlign="center" color="gray.500">
              Tente novamente mais tarde.
            </Text>
          </VStack>
        )}
      </VStack>
    </>
  );
}

export default React.memo(ListaMedicos);
